import Joi from 'joi';

export const EmergencySchema = Joi.object({
  name: Joi.string().required(),
  description: Joi.string().required(),
  emergencyDate: Joi.date().required(),
});

export const EmergencyAttachmentSchema = Joi.object({
  name: Joi.string().required(),
  file: Joi.string().required(),
});
